import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import Seo from "@/components/layout/Seo";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="not-found-page">
      <Seo title={t("notFound")} noindex />
      <p className="font-display text-6xl font-bold text-gold">404</p>
      <h1 className="mt-4 text-2xl font-bold text-navy">{t("notFound")}</h1>
      <Link to="/" className="btn-navy mt-8">{t("goHome")}</Link>
    </div>
  );
}
